export const uk = {
    'error-refresh': 'Возникла ошибка. Попробуйте обновить страницу.',
    'success-cooperation-request':
        'Спасибо за отправленный запрос! Пожалуйста, ожидайте, пока с вами свяжется специалист или обратитесь к нему по контактам на этой странице'
};
